import { Star, Quote } from "lucide-react";
import { Reveal } from "./Reveal";

const reviews = [
  {
    name: "Vinmaya Prajapati",
    location: "Kathmandu",
    rating: 5,
    text: "Service are very excellent. I am so happy to receive service at such an affordable price. The doctors are also very nice and experienced. The location is also very suitable.",
  },
  {
    name: "Aayush Bhandari",
    location: "Kathmandu",
    rating: 5,
    text: "Great hospital! Centrally located, easy to reach, and very affordable. The staff are caring, the doctors are professional, and the facilities are clean. Highly recommend for quality care at a good price!",
  },
  {
    name: "Prity Saud",
    location: "Kathmandu",
    rating: 4,
    text: "It's multi speciality hospital. The hospital provides excellent care and has very helpful staff. The environment is clean, organized, and patient-friendly. Highly recommend this hospital for quality treatment.",
  },
];

const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/place/Kathmandu+National+Medical+College+%26+Teaching+Hospital/@27.7146009,85.3128468,17574m/data=!3m1!1e3!4m10!1m2!2m1!1skathmandu+national+medical+college!3m6!1s0x39eb190072109b9b:0xb0012b338dcda4f5!8m2!3d27.7015003!4d85.327544!15sCiJrYXRobWFuZHUgbmF0aW9uYWwgbWVkaWNhbCBjb2xsZWdlWiQiImthdGhtYW5kdSBuYXRpb25hbCBtZWRpY2FsIGNvbGxlZ2WSAQhob3NwaXRhbJoBRENpOURRVWxSUVVOdlpFTm9kSGxqUmpsdlQyeENXbFJHUm1oU1YzUlJWVlZhZDA1c2NHNVpiVTVMVFVkMFVGbHVZeEFC4AEA-gEECGsQPQ!16s%2Fg%2F11vwj6bs2q?entry=ttu&g_ep=EgoyMDI2MDgwNS4xIKXMDSoASAFQAw%3D%3D";

function RatingStars({
  rating,
  size = 16,
}: {
  rating: number;
  size?: number;
}) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, index) => {
        const fill = Math.max(0, Math.min(1, rating - index));

        return (
          <div
            key={index}
            className="relative"
            style={{ width: size, height: size }}
          >
            {/* Empty star */}
            <Star
              size={size}
              className="absolute inset-0 text-border"
              strokeWidth={1.8}
            />

            {/* Filled portion */}
            <div
              className="absolute inset-0 overflow-hidden"
              style={{ width: `${fill * 100}%` }}
            >
              <Star
                size={size}
                className="fill-gold text-gold"
                strokeWidth={1.8}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function Testimonials() {
  const overallRating = 4.6;

  return (
    <section className="bg-surface py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-12 flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-xl">
            <p className="mb-2 text-sm font-medium uppercase tracking-wider text-secondary">
              Patient Stories
            </p>
            <h2 className="font-display text-3xl font-semibold text-primary md:text-5xl">
              Trusted by thousands across Nepal
            </h2>
          </div>

          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 rounded-full bg-card px-5 py-3 shadow-soft transition-all duration-300 hover:-translate-y-0.5 hover:shadow-elevated hover:ring-1 hover:ring-gold/40"
          >
            <RatingStars rating={overallRating} />
            <span className="text-sm font-semibold underline-offset-2 hover:underline text-foreground">
              {overallRating} · 50+ Google reviews
            </span>
          </a>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {reviews.map((review, index) => (
            <Reveal key={review.name} delay={index * 120}>
              <figure className="hover-lift relative flex h-full flex-col justify-between rounded-2xl border border-border bg-card p-8 shadow-soft hover:border-gold/40">
                <div>
                  <Quote className="absolute right-6 top-6 h-8 w-8 text-primary/10" />

                  <RatingStars rating={review.rating} />

                  <blockquote className="mt-5 text-base leading-relaxed text-foreground">
                    &ldquo;{review.text}&rdquo;
                  </blockquote>
                </div>

                <figcaption className="mt-6 border-t border-border pt-4">
                  <div className="font-semibold text-foreground">
                    {review.name}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {review.location}
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}